// migrated 1:1 from @nexato/nx-core-module, #688
import { Activity } from "../../../entities/activity/activity";
import { ActivityComponent } from "./activityComponent";
import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-entity-links-updated',
  template: `
    <ng-template #linkTemplate let-link let-removed="removed">
      <div class="inline-flex items-center text-[12px] border rounded-md overflow-hidden hover:shadow-sm transition-shadow h-5 cursor-pointer hover:underline"
           [style.border-color]="removed ? '#FEE2E2' : '#EAEEEF'" (click)="goToEntityDetails(link)">
        <span class="px-2 py-1 font"
              [class.line-through]="removed"
              [style.background-color]="removed ? '#FEE2E2' : '#EAEEEF'"
              [style.color]="removed ? '#991B1B' : '#000000ff'">
          {{translateEntityType(link.linkedEntityType)}}: {{link.text}}
        </span>
      </div>
    </ng-template>

    <b>{{activity()?.actor?.displayName}}</b> hat Verknüpfungen geändert <app-relative-time [timestamp]="activity()?.createdDateTime" />:
    <!-- Added links -->
    @for (link of activity()?.viewModel?.addedLinks; track link.linkedEntityId) {
      <ng-container *ngTemplateOutlet="linkTemplate; context: { $implicit: link, removed: false }"></ng-container>
    }
    <!-- Removed links -->
    @for (link of activity()?.viewModel?.removedLinks; track link.linkedEntityId) {
      <ng-container *ngTemplateOutlet="linkTemplate; context: { $implicit: link, removed: true }"></ng-container>
    }
  `
})
export class EntityLinksUpdatedComponent implements ActivityComponent {

  private readonly router = inject(Router);
  readonly activity = input.required<Activity>();
  readonly ownerId = input<string>();

  private readonly entityTypeTranslations: Record<string, string> = {
    'Resource': 'Ressource',
    'Task': 'Aufgabe',
    'Contact': 'Kunde',
    'Order': 'Auftrag'
  };

  translateEntityType(type: string): string {
    return this.entityTypeTranslations[type] ?? type;
  }

  goToEntityDetails(link: any): void {
    const url = this.buildEntityDetailsUrl(link);
    if (url) {
      this.router.navigateByUrl(url);
    }
  }

  private buildEntityDetailsUrl(link: any): string {
    if (link?.linkedEntityType === 'Contact') {
      return `/customers/customer/${link.linkedEntityId}`;
    }
    if (link?.linkedEntityType === 'Resource') {
      return `/resources/resource/${link.linkedEntityId}`;
    }
    if (link?.linkedEntityType === 'Order') {
      return `/orders/order/${link.linkedEntityId}`;
    }
    if (link?.linkedEntityType === 'Task') {
      return `/tasks/task/${link.linkedEntityId}`;
    }
    return '';
  }
}
